import React from "react";
import { Button } from "@creditonebank/c1b-components";
import { ReactComponent as ReloadButton } from "../../assets/ReloadButton.svg";
import { ReactComponent as BadgeIconError } from "../../assets/BadgeIconError.svg";


const SiteUnavailable = () => {

    const signInWidget = (() => {
        window.location.replace("/")
    })

    return (
        <div className="bg-site">
            <div className="site-unavailable-screen-container">
                <div className="site-title">
                    <BadgeIconError className="badge" />
                    <h4>We ran into a technical issue</h4>
                    <p className="site-subtext">Sorry, we're having a bit of trouble on our end. Please try again or check back later.</p>
                </div>
                <div className="site-footer">
                    <ReloadButton className="reload-button-badge" onClick={signInWidget}></ReloadButton>
                </div>
            </div>
        </div>
    );
}

export default SiteUnavailable